const { NODE_ENV } = process.env;

const apiCopomexToken = NODE_ENV === 'production' ? '1549a77d-fd34-4c88-be0e-433be3290ab4' : 'pruebas';

export default apiCopomexToken;